import { MaritalRegime, MaritalStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const maritalStatusArray = Object.keys(MaritalStatus).map((status) => ({
  value: status.toLowerCase(),
  display: <Text tId={status.toLowerCase()} />,
}));

export const maritalRegimeArray = Object.keys(MaritalRegime).map((status) => ({
  value: status.toLowerCase(),
  display: <Text tId={status.toLowerCase()} />,
}));
